import { bus } from "../main";
import { centerPreviewEnabled } from "../utils/centerAvailabilityPreview.mjs";
import { CENTER_BLOCKED_REFRESH_MS, CENTER_REFRESH_MS } from "../utils/centerAvailability.mjs";

/** One observer for the advancement area, not one poller per ODP/card. */
export const centerAvailabilityObserver = {
    computed: {
        centerAreaActive() { return /^\/av(?:\/|$)/.test(this.$route.path) && centerPreviewEnabled(this.$store.state); },
    },
    watch: {
        "$store.state.user.token"() { this.$nextTick(() => this.refreshCenterAvailability()); },
        "$store.state.centerAvailability.attemptedAt"() {
            // Align the fallback with event-triggered reads instead of waiting an extra tick.
            if (!this._centerAvailabilityTimer) return;
            clearInterval(this._centerAvailabilityTimer);
            this._centerAvailabilityTimer = setInterval(this.pollCenterAvailability, CENTER_BLOCKED_REFRESH_MS);
        },
        centerAreaActive: { immediate: true, handler(active) { if (active) this.refreshCenterAvailability(); } },
        "$store.state.socketmessage"(message) {
            if (centerPreviewEnabled(this.$store.state) && (message?.meta?.ordine || message?.meta?.operazione)) {
                this.$store.commit("centerAvailability/invalidate");
                this.refreshCenterAvailability();
            }
        },
    },
    created() { this.$store.dispatch("centerAvailability/restorePreference"); },
    mounted() {
        bus.$on("reloadavanzamenti", this.invalidateCenterAvailability);
        this._centerAvailabilityTimer = setInterval(this.pollCenterAvailability, CENTER_BLOCKED_REFRESH_MS);
        this._centerAvailabilityClock = setInterval(() => {
            if (this.centerAreaActive && !document.hidden) this.$store.commit("centerAvailability/tick");
        }, 10000);
        document.addEventListener("visibilitychange", this.refreshCenterAvailability);
        window.addEventListener("focus", this.refreshCenterAvailability);
    },
    beforeDestroy() {
        bus.$off("reloadavanzamenti", this.invalidateCenterAvailability);
        clearInterval(this._centerAvailabilityTimer);
        clearInterval(this._centerAvailabilityClock);
        document.removeEventListener("visibilitychange", this.refreshCenterAvailability);
        window.removeEventListener("focus", this.refreshCenterAvailability);
    },
    methods: {
        pollCenterAvailability() {
            if (!this.centerAreaActive || document.hidden) return;
            const waiting = Object.values(this.$store.state.centerAvailability.waiting || {}).some(Boolean);
            this.$store.dispatch("centerAvailability/refresh", {
                work: this.$work, background: true, canRefresh: () => this.centerAreaActive && !document.hidden,
                maxAge: waiting ? CENTER_BLOCKED_REFRESH_MS : CENTER_REFRESH_MS,
            });
        },
        invalidateCenterAvailability() {
            if (!centerPreviewEnabled(this.$store.state)) return;
            this.$store.commit("centerAvailability/invalidate");
            this.refreshCenterAvailability();
        },
        refreshCenterAvailability() {
            if (this.centerAreaActive && !document.hidden) this.$store.dispatch("centerAvailability/refresh", {
                work: this.$work, canRefresh: () => this.centerAreaActive && !document.hidden,
            });
        },
    },
};
